import React from 'react';

import { Link, type LinkProps } from 'react-router';

import Button, { type ButtonProps } from 'common/uiV3/Button';

type BaseButtonProps = Omit<ButtonProps, 'asChild' | 'children'>;

type AnchorButtonLinkProps = BaseButtonProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof BaseButtonProps> & {
    href: string;
    to?: never;
  };

type LinkButtonLinkProps = BaseButtonProps &
  Omit<LinkProps, keyof BaseButtonProps> & {
    to: string;
    href?: never;
  };

export type ButtonLinkProps = AnchorButtonLinkProps | LinkButtonLinkProps;

const ButtonLink = (props: ButtonLinkProps) => {
  const {
    variant,
    size,
    color,
    isLoading,
    disabled,
    tintColor,
    iconOnly,
    fullWidth,
    responsive,
    children,
    href,
    to,
    ...restProps
  } = props;

  const buttonProps: ButtonProps = {
    variant,
    size,
    color,
    isLoading,
    disabled,
    tintColor,
    iconOnly,
    fullWidth,
    responsive,
    asChild: true,
  };

  const isExternalLink = !!href;

  const getContent = () => {
    if (isExternalLink) {
      return (
        <a href={href} target="_blank" rel="noopener" {...(restProps as any)}>
          {children}
        </a>
      );
    }
    return (
      <Link to={to!} {...(restProps as any)}>
        {children}
      </Link>
    );
  };

  return <Button {...buttonProps}>{getContent()}</Button>;
};

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;
